import React from 'react'
import './index.css'

const Index = ({Value,Action}) => {
  return (
    <div className='panelcontrols_panelbutton_table'>
      <button onClick={Action}>{Value}</button>
    </div>
  )
}

export default Index
